import { Component, OnInit } from "@angular/core";
import {
  ActivatedRoute,
  NavigationEnd,
  Router,
  RouterEvent,
} from "@angular/router";
import { filter, timeInterval } from "rxjs";
import { HomeConstant } from "src/constants/global-constants";
import {
  featureFlag,
  featureFlagListResponse,
  featureFlagResponse,
} from "src/models/featureFlag";
import { UserDetailProfile } from "src/models/profile";
import { FacebookPixelService } from "src/services/facebook-pixel.service";
import { ClarityService } from "src/services/clarity.service";
import { FeatureFlagService } from "src/services/feature-flag.service";
import { UserAuthService } from "src/services/user-auth.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  standalone: false,
})
export class AppComponent implements OnInit {
  showSideBar: boolean = false;

  mainTabs: any[] = [];
  warning_action_text: string | undefined = "";
  warning_message_text: string | undefined = "";
  show_warning: boolean = false;
  userInfo!: any;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private featureFlagService: FeatureFlagService,
    public userAuthService: UserAuthService,
    private pixelService: FacebookPixelService,
    private clarityService: ClarityService
  ) {
    this.clarityService.clarityInit();

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event) => {
        const routePath = (event as RouterEvent).url.split("?")[0];
        const hideSideBarRoutes = [
          "/login",
          "/signup",
          "/password-recovery",
          "/create-new-password",
          "/bank-detail",
          "/user-profile",
          "/address-detail",
        ];
        this.showSideBar = !hideSideBarRoutes.includes(routePath);

        if (
          ["/terms-of-service", "/registration-fee-page"].includes(routePath)
        ) {
          this.activatedRoute.queryParams.subscribe((queryParams) => {
            this.showSideBar = queryParams["redirect"] !== "true";
          });
        }
      });
    this.getAllFeatureFlags();
    this.userAuthService.authChange$.subscribe(() => {
      this.initialize();
    });
  }
  ngOnInit(): void {
    this.initialize();
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.pixelService.resetEvents();
        this.pixelService.trackPageView();
      });
  }

  initialize() {
    if (this.userAuthService.accessToken) {
      this.fetchProfileDetails();
    } else {
      this.fetchTabs();
    }
  }

  getAllFeatureFlags() {
    this.featureFlagService.fetchAllFeatureFlags().subscribe({
      next: (res: featureFlagListResponse) => {
        this.featureFlagService.setFeatureFlags(res.data);
        console.log("Feature Flags:", res.data);
      },
      error: (err) => {
        console.error("Feature Flags Error:", err);
      },
    });
  }

  fetchTabs() {
    const flagName: string = "TAB_ORDER";
    const flags: featureFlag[] = this.featureFlagService.getFeatureFlags();
    const flagIndex = flags.findIndex((item) => item.name == flagName);
    if (flagIndex < 0) {
      this.featureFlagService.fetchFeatureFlag(flagName).subscribe({
        next: (res: featureFlagResponse) => {
          this.mainTabs = [
            ...this.reOrderTabsList(res.data.additional_details.data),
          ];
          localStorage.setItem("tabs", JSON.stringify(this.mainTabs));
          console.log(`Feature Flag: ${flagName}:`, res.data);
        },
        error: (err) => {
          console.error(`Feature Flag Error: ${flagName}:`, err);
        },
      });
    } else {
      this.mainTabs = [
        ...this.reOrderTabsList(flags[flagIndex].additional_details.data),
      ];
      localStorage.setItem("tabs", JSON.stringify(this.mainTabs));
    }
  }

  reOrderTabsList(tabListFromFeatureFlag: any[]): any[] {
    const tabs = [...HomeConstant.MainTabs];
    let mainTabs: any[] = [];
    tabListFromFeatureFlag.forEach((tab) => {
      const tabFound = tabs.find((t) => t.tab_name == tab.tab_name);
      if (tabFound) {
        const isVisibleWhenLoggedOut = tab.display_if_logged_out;
        const isVisibleWhenLoggedIn =
          this.userAuthService.accessToken &&
          this.userInfo?.info[
            `show_${tabFound.tab_name.toLowerCase().replace(/ /g, "_")}`
          ];

        if (isVisibleWhenLoggedOut || isVisibleWhenLoggedIn) {
          mainTabs.push(tabFound);
        }
      }
    });
    return mainTabs;
  }

  fetchProfileDetails() {
    this.userAuthService.fetchProfileDetails().subscribe({
      next: (response: UserDetailProfile) => {
        console.log("User Profile:", response);
        this.userInfo = response.data;
        this.show_warning = this.userInfo.show_warning;
        this.warning_action_text = this.userInfo.warning_action_text;
        this.warning_message_text = this.userInfo.warning_message_text;
        this.fetchTabs();
      },
      error: (err: any) => {
        console.error("User Profile Error:", err);
      },
    });
  }
}
